import { useAnalytics } from '../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../helpers/analytics/trackEvent';
import { getMapWithFishrulesSpeciesUrl } from '../../helpers/urls';
import { ICoordinates } from '../../interfaces/geo';
import { NonCrawlableLink } from '../Clickables/NonCrawlableLink/NonCrawlableLink';

interface IChangeLocation {
  coordinates: ICoordinates;
  fishrulesSpeciesId: number | undefined;
  eventSource: string;
}

export const ChangeLocation = ({
  coordinates,
  fishrulesSpeciesId,
  eventSource,
}: IChangeLocation) => {
  const { currentPage } = useAnalytics();

  return (
    <div className="mx-auto h-fit pb-4 sm:mx-0 sm:pr-8 sm:pb-0">
      <NonCrawlableLink
        variant="buttonPrimary"
        onClickEvent={() => {
          void trackEvent({
            name: 'mykiss_cta_button_clicked',
            properties: {
              type: 'read-more',
              source: eventSource,
              page: currentPage,
            },
          });
        }}
        routerPushTo={getMapWithFishrulesSpeciesUrl(
          coordinates.latitude,
          coordinates.longitude,
          fishrulesSpeciesId,
        )}
        ariaLabel="Regulations in the map"
      >
        Regulations in the map
      </NonCrawlableLink>
    </div>
  );
};
